import { createSlice } from "@reduxjs/toolkit";
import { USER_ROLES } from "../../app.constants";
import type { RootState } from "../../app.store";
import type { AuthInitialState, UserInfo, VerifyPayload } from "./auth.types";

const initialState: AuthInitialState = {
  theme: "dark",
  role: undefined,
  modulesInfo: [],
  permissionsInfo: [],
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    verifyUser: (state, { payload }: { payload: VerifyPayload }) => {
      state.verifiedInfo = payload?.user;
      state.access_token = payload?.access_token;
      state.userId = payload?.user?.id;
    },
    userLoggedOut: (state) => {
      state.userId = undefined;
      state.userInfo = undefined;
      state.profileInfo = undefined;
      state.access_token = undefined;
      state.verifiedInfo = undefined;
      state.permissionsInfo = [];
      state.modulesInfo = [];

      // Clear localStorage
      localStorage.clear();
    },
    setAuthInfo: (state, { payload }: { payload: UserInfo }) => {
      state.userInfo = payload;
      state.userId = payload?.userId;
    },
    setProfileInfo: (state, { payload }) => {
      state.profileInfo = payload;
      if (state.permissionsInfo.length) return;
      if (
        payload.role !== "admin" &&
        payload?.is_evaluator &&
        payload?.is_manager
      ) {
        state.role = USER_ROLES.EVALUATOR_MANAGER;
        return;
      } else if (
        payload.role !== "admin" &&
        payload?.is_evaluator &&
        !payload?.is_manager
      ) {
        state.role = USER_ROLES.EVALUATOR_USER;
        return;
      }
      if (payload.role !== "admin" && payload?.is_evaluator) {
        state.role = USER_ROLES.EVALUATOR;
        return;
      }
      if (payload.role !== "admin" && payload?.is_manager) {
        state.role = USER_ROLES.LINE_MANAGER;
        return;
      } else {
        state.role = USER_ROLES.USER;
      }
      // toast("error", "Insufficient permissions.");
    },
    setModulesInfo: (state, { payload }) => {
      state.modulesInfo = payload;
    },
    setPermissionsInfo: (state, { payload }) => {
      if (state.role !== USER_ROLES.ADMIN && payload?.length > 0) {
        state.role = USER_ROLES.ADMIN;
      }
      state.permissionsInfo = payload;
    },
    setTheme: (state, action) => {
      state.theme = action.payload;
      if (typeof window !== "undefined") {
        localStorage.setItem("theme", action.payload);
      }
    },
    toggleTheme: (state) => {
      state.theme = state.theme === "light" ? "dark" : "light";
      // if (typeof window !== 'undefined') {
      //   localStorage.setItem('theme', state.theme);
      // }
    },
  },
});

export const {
  userLoggedOut,
  setAuthInfo,
  toggleTheme,
  verifyUser,
  setTheme,
  setProfileInfo,
  setModulesInfo,
  setPermissionsInfo,
} = authSlice.actions;
export const authReducer = authSlice.reducer;

/* ------ Selectors ------ */
export const selectAuth = (state: RootState) => state.auth;
